export const menuItems = [
   {
    key: 'viewDashboard',
    value: 'Dashboard',
    path: 'dashboard',
    viewValue: 'Dashboard',
    imgURL: '../../assets/images/dashboard.svg',
    activeimgURL: '../../assets/images/dashboard.svg',
  },
   {
    key: 'viewManagement',
    value: 'Management',
    path: 'management',
    viewValue: 'Management',
    imgURL: '../../assets/images/management.svg',
    activeimgURL: '../../assets/images/management.svg',
  },
  {
    key: 'viewOnboarding',
    value: 'Onboarding',
    path: 'onboarding',
    viewValue: 'Onboarding',
    imgURL: '../../assets/images/onboarding.svg',
    activeimgURL: '../../assets/images/onboarding.svg',
  },
  {
    key: 'viewFaq',
    value: 'FAQ',
    path: 'faq',
    viewValue: 'FAQ',
    imgURL: '../../assets/images/faq.svg',
    activeimgURL: '../../assets/images/faq.svg',
  },
  {
    key: 'viewChats',
    value: 'Chats',
    path: 'chats',
    viewValue: 'Chats',
    imgURL: '../../assets/images/mail_icon.svg',
    activeimgURL: '../../assets/images/mail_icon.svg',
  },
  {
    key: 'viewTransactions',
    value: 'Fund Operations',
    path: 'transactions',
    viewValue: 'Fund Operations',
    imgURL: '../../assets/images/fundoperation_icon_active.svg',
    activeimgURL: '../../assets/images/fundoperation_icon_active.svg',
    subMenus: [
      {
        key: 'viewBankTransactions',
        value: 'Transactions',
        path: 'bank',
        viewValue: 'Bank',
        imgURL: '../../assets/images/transactions_icon.svg',
        activeimgURL: '../../assets/images/transactions_icon_active.svg',
      },
      {
        key: 'viewBankAccounts',
        value: 'Bank accounts',
        path: 'bank-accounts',
        viewValue: 'Bank accounts',
        imgURL: '../../assets/images/bank_icon.svg',
        activeimgURL: '../../assets/images/bank_icon_active.svg',
      },
      {
        key: 'viewInvoices',
        value: 'Invoices',
        path: 'invoices',
        viewValue: 'Invoices',
        imgURL: '../../assets/images/invoices_icon.svg',
        activeimgURL: '../../assets/images/invoices_icon_active.svg',
      },
      {
        key: 'viewCounterparts',
        value: 'Counterparties',
        path: 'counterparties',
        viewValue: 'Counterparts',
        imgURL: '../../assets/images/counterparts_icon.svg',
        activeimgURL: '../../assets/images/counterparts_icon_active.svg',
      },
      {
        key: 'viewTransactions',
        value: 'Capital calls',
        path: 'capital-calls',
        viewValue: 'Capital calls',
        imgURL: '../../assets/images/capital-call-icon.svg',
        activeimgURL: '../../assets/images/capital-call-icon-active.svg',
      },
    ],
    isToggled: false,
  },
  {
    key: 'viewPortfolioGroup',
    value: 'Portfolio',
    path: 'portfolio-group',
    viewValue: 'Portfolio',
    imgURL: '../../assets/images/pc_icon.svg',
    activeimgURL: '../../assets/images/pc_icon_active.svg',
    subMenus: [
      {
        key: 'viewPortfolioCompanies',
        value: 'Portfolio',
        path: 'portfolio',
        viewValue: 'Portfolio',
        imgURL: '../../assets/images/pc_icon.svg',
        activeimgURL: '../../assets/images/pc_icon.svg',
      },
      {
        key: 'viewQuarterlyData',
        value: 'Quarterly data',
        path: 'quarterly-data',
        viewValue: 'Quarterly data',
        imgURL: '../../assets/images/quarterly_data_icon.svg',
        activeimgURL: '../../assets/images/quarterly_data_icon.svg',
      },
      /*
      {
        key: 'viewReports',
        value: 'Reports',
        path: 'reports',
        viewValue: 'Reports',
        imgURL: '../../assets/images/reports_icon_v1.svg',
        activeimgURL: '../../assets/images/reports_icon_active_v1.svg',
      },
      */
      {
        key: 'viewReports',
        value: 'Reports',
        path: 'new-reports',
        viewValue: 'Reports',
        imgURL: '../../assets/images/reports_icon_v1.svg',
        activeimgURL: '../../assets/images/reports_icon_active_v1.svg',
      },
    ],
    isToggled: false,
  },
  {
    key: 'viewInvestors',
    value: 'Investors',
    path: 'investors',
    viewValue: 'Investors',
    imgURL: '../../assets/images/investors.svg',
    activeimgURL: '../../assets/images/investors.svg',
  },
   /*{
    key: 'viewDocuments',
    value: 'Documents',
    path: 'documents',
    viewValue: 'Documents',
    imgURL: '../../assets/images/documents_icon.svg',
    activeimgURL: '../../assets/images/documents_icon_active.svg',
  },*/
  {
    key: 'viewTeam',
    value: 'Team',
    path: 'team',
    viewValue: 'Team',
    imgURL: '../../assets/images/team.svg',
    activeimgURL: '../../assets/images/team.svg',
  },
  {
    key: 'viewChat',
    value: 'Chats',
    path: 'chat',
    viewValue: 'Chats',
    imgURL: '../../assets/images/chats.svg',
    activeimgURL: '../../assets/images/chats.svg',
  },
  {
    key: 'viewSettings',
    value: 'Settings',
    path: 'settings',
    viewValue: 'Settings',
    imgURL: '../../assets/images/settings_icon.svg',
    activeimgURL: '../../assets/images/settings_icon_active.svg',
    subMenus: [
      {
        key: 'viewUserManagement',
        value: 'User management',
        path: 'user-management',
        viewValue: 'User management',
        imgURL: '../../assets/images/settings_icon.svg',
        activeimgURL: '../../assets/images/settings_icon_active.svg',
      },
      {
        key: 'viewApprovalPolicies',
        value: 'Approval Policies',
        path: 'approval-policies',
        viewValue: 'Approval Policies',
        imgURL: '../../assets/images/approval_icon.svg',
        activeimgURL: '../../assets/images/approval_icon_active.svg',
      },
      {
        key: 'viewFinoBankAccounts',
        value: 'Fino Bank acc',
        path: 'fino-bank-accounts',
        viewValue: 'Fino Bank acc',
        imgURL: '../../assets/images/bank_icon.svg',
        activeimgURL: '../../assets/images/bank_icon_active.svg',
      },
      {
        key: 'viewPaymentApproval',
        value: 'Payment approval',
        path: 'payment-approval',
        viewValue: 'Payment approval',
        imgURL: '../../assets/images/settings_icon.svg',
        activeimgURL: '../../assets/images/settings_icon.svg',
      },
      {
        key: 'viewDnsEntries',
        value: 'DNS entries',
        path: 'dns-entries',
        viewValue: 'DNS entries',
        imgURL: '../../assets/images/settings_icon.svg',
        activeimgURL: '../../assets/images/settings_icon.svg',
      },
      {
        key: 'viewLetterHeads',
        value: 'Letterheads',
        path: 'letterheads',
        viewValue: 'Letterheads',
        imgURL: '../../assets/images/settings_icon.svg',
        activeimgURL: '../../assets/images/settings_icon.svg',
      },
    ],
    isToggled: false,
  },
];

/**
 * Onboarding-only view (PoC, gated by `environment.onboardingOnlyMode`).
 *
 * The sidebar sections a GP whose only live activity is onboarding actually uses.
 * Anything absent from this list is hidden from the sidebar: Fund Operations and its
 * children, the Portfolio group (Portfolio / Quarterly data / Reports), and Settings.
 *
 * Presentational only -- the filter that consumes this runs after HomeComponent's URL
 * validation, so hidden sections stay reachable by direct URL and no route, component
 * or module declaration is removed.
 */
export const ONBOARDING_ONLY_MENU_KEYS = [
  'viewDashboard',
  'viewManagement', // the task board -- this is "Tasks"
  'viewOnboarding',
  'viewChat',
  'viewFaq',
  'viewInvestors',
  'viewDocuments',
  'viewTeam',
];
